import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

class DealListDropdownItem extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const { onClick, item, isSelected } = this.props;

        return (
            <div
                className={`deal-list-dropdown-item-container deal-item ${isSelected ? 'selected-item' : ''}`}
                onClick={onClick}
            >
                <div
                    className={`deal-list-dropdown-item-container icon-container ${isSelected ? 'selected-item' : ''}`}
                >
                    <i className="material-icons-outlined">{isSelected ? 'check' : 'list'}</i>
                    <span className="body-1">{item.name}</span>
                </div>
                <span className="subtitle">{item.dealsCount}</span>
            </div>
        );
    }
}

DealListDropdownItem.propTypes = {
    item: PropTypes.object,
    isSelected: PropTypes.bool,
};

export default injectIntl(DealListDropdownItem);
